(function () {
    angular
        .module('app')
        .factory('eventTracker', eventTracker);

    function eventTracker() {
        var service = this;
        service.userSignup = userSignup;
        service.artistSignup = artistSignup;
        service.hostSignup = hostSignup;
        service.impressionView = impressionView;
        service.detailView = detailView;
        service.productClick = productClick;
        service.addToCart = addToCart;
        service.removeFromCart = removeFromCart;
        service.checkout = checkout;
        service.purchase = purchase;
        var dataLayer = window.dataLayer || [];
        var listNames =  {
            'list_concerts': 'Concerts Page Concert List',
            'frontpage': 'Frontpage Concert List',
            'host_profile': 'Host Profile Concert List',
            'musician_profile': 'Musician Profile Concert List',
            'concert_link': 'Concert Link'
        };

        function userSignup(data) {
            var response = dataLayer.push({
                'event': 'userSignup',
                'country': data.country
            });
            return response;
        }

        function artistSignup(data) {
            var response = dataLayer.push({
                'event': 'artistSignup',
                'country': data.country, 
                'region': data.region, 
                'careerState': data.careerState, 
                'genre': data.genre //Main genre dynamically inserted
            });
            return response;
        }

        function hostSignup(data) {
            var response = dataLayer.push({
                'event': 'hostSignup',
                'country': data.country, 
                'region': data.region, 
                'spaceType': data.spaceType, 
                'capacity': data.capacity, 
                'genre': data.genre 
            });
            return response;
        }

        function impressionView(concerts, list, page) {
            var dataLayerConcerts = [];
            concerts.forEach(function (concert) {
                var concert_position = concerts.map(function(o) { return o.concert_slug; }).indexOf(concert.concert_slug)+1;
                var concert = 
                {
                    id: concert.concert_slug,
                    name: concert.concert_name,
                    price: concert.concert_price,
                    artist: concert.band_name,
                    category: concert.band_main_genre,
                    host: concert.space_name,
                    city: concert.concert_city,
                    date: concert.concert_start_time,
                    list: list, 
                    position: page ? (concert_position * page) : concert_position
                }
                dataLayerConcerts.push(concert);
            });
            var response = dataLayer.push({
                event: 'impressionView',
                ecommerce: {
                  currencyCode: dataLayerConcerts[0].concert_currency, 
                  impressions: dataLayerConcerts
                }
            });

            return response;
        }

        function detailView(concerts, list) {
            var dataLayerConcerts = [];
            concerts.forEach(function (concert) {
                var concert = 
                {
                    id: concert.concert_slug,
                    name: concert.concert_name,
                    price: concert.concert_price,
                    artist: concert.band_name,
                    category: concert.band_main_genre,
                    host: concert.space_name,
                    city: concert.concert_city,
                    date: concert.concert_start_time
                }
                dataLayerConcerts.push(concert);
            });
            var response = dataLayer || [];
            window.dataLayer.push({
                event: 'detail',
                ecommerce: {
                    currencyCode: dataLayerConcerts[0].concert_currency, 
                    detail: {
                        actionField: {
                            list: list
                        },
                        products: [
                            dataLayerConcerts
                        ]
                    }
                }
            });            

            return response;
        }

        function productClick(concert, list) {
            var response = dataLayer.push({
                event: 'productClick',
                ecommerce: {
                    currencyCode: concert.concert_currency, 
                    click: {
                        actionField: {
                            list: list
                        },
                        products: [{
                        id: concert.concert_slug,
                        name: concert.concert_name,
                        price: concert.concert_price,
                        artist: concert.band_name,
                        category: concert.band_main_genre,
                        host: concert.space_name,
                        city: concert.concert_city,
                        date: concert.concert_start_time, 
                        position: concert.position
                        }]
                      
                    }
                }
            }); 

            return response;
        }

        function addToCart(concert, list, ticket_amount){
            var response = dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                    currencyCode: concert.concert_currency, 
                    add: {
                        actionField: {
                            list: getListName(list)
                        },
                        products: [{
                            id: concert.concert_slug,
                            name: concert.concert_name,
                            price: concert.concert_price, 
                            artist: concert.band_name,
                            category: concert.band_main_genre,
                            host: concert.space_name,
                            city: concert.concert_city,
                            date: concert.concert_start_time,
                            quantity: ticket_amount
                        }]
                    }
                }
              });

            return response;
        }

        function removeFromCart(concert, list, ticket_amount){
        var response = dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
            currencyCode: concert.concert_currency,
                remove: {
                    actionField: {
                        list: getListName(list)
                    },
                    products: [{
                        id: concert.concert_slug,
                        name: concert.concert_name,
                        price: concert.concert_price, 
                        artist: concert.band_name,
                        category: concert.band_main_genre,
                        host: concert.space_name,
                        city: concert.concert_city,
                        date: concert.concert_start_time,
                        quantity: ticket_amount
                    }]
                }
            }
        });
              
            return response;
        }

        function checkout(concert, ticket_amount){
            var response = dataLayer.push({
                event: 'checkout',
                ecommerce: {
                    currencyCode: concert.concert_currency,
                    checkout: {
                        products: [{
                            id: concert.concert_slug,
                            name: concert.concert_name,
                            price: concert.concert_price, 
                            artist: concert.band_name,
                            category: concert.band_main_genre,
                            host: concert.space_name,
                            city: concert.concert_city,
                            date: concert.concert_start_time,
                            quantity: ticket_amount
                        }]
                    }
                }
            });

            return response;
        }

        function purchase(concert, ticket_amount, checkout_id, checkout_total){
            var response = dataLayer.push({
            event: 'purchase',
            ecommerce: {
                currencyCode: concert.concert_currency,
                purchase: {
                    actionField: {
                        id: checkout_id, //Order ID for the purchase
                        revenue: checkout_total, //Revenue without comma
                        tax: checkout_total * 0.75  //Tax if relevant. No commas
                    },
                    products: [{
                        id: concert.concert_slug,
                        name: concert.concert_name,
                        price: concert.concert_price, 
                        artist: concert.band_name,
                        category: concert.band_main_genre,
                        host: concert.space_name,
                        city: concert.concert_city,
                        date: concert.concert_start_time,
                        quantity: ticket_amount
                    }]
                }
            }
            });
              
            return response;
        }

        function getListName(listSlug){
            return listNames[listSlug];
        }

        return service;
    }
})();